import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeVatReturnRowCreate,
  detail: routeVatReturnRowDetail,
  home: routeVatReturnRowsHome,
  root: routeVatReturnRowsRoot,
} = createDoctypeRoutes({
  createName: 'new-vat-return-row',
  createPath: 'new-vat-return-row',
  detailName: 'vatReturnRowDetail',
  doctype: DOCTYPES.TW_VAT_RETURN_ROW,
  homeName: 'vat-return-rows',
  path: 'vat-return-rows',
  views: {
    create: async () =>
      await import(
        '@/components/viewsExternal/settings/accounting/reportMapping/AddVatReturnRow.vue'
      ),
    detail: async () =>
      await import(
        '@/components/viewsExternal/settings/accounting/reportMapping/ViewVatReturnRow.vue'
      ),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export {
  routeVatReturnRowCreate,
  routeVatReturnRowDetail,
  routeVatReturnRowsHome,
  routeVatReturnRowsRoot,
}
